import React from 'react';
import { useNode, Element } from '@craftjs/core';
import { useTheme } from '../../../contexts/ThemeContext';

export const ContainerBlock = ({ children, backgroundColor, padding, borderRadius }) => {
  const { isDark } = useTheme();
  const { connectors: { connect, drag }, selected } = useNode((state) => ({
    selected: state.events.selected
  }));

  return (
    <div
      ref={(ref) => ref && connect(drag(ref))}
      className={`min-h-[100px] rounded-lg transition-all ${
        selected ? 'ring-2 ring-[#A2FF00]' : ''
      }`}
      style={{
        backgroundColor: backgroundColor || 'transparent',
        padding: `${padding || 16}px`,
        borderRadius: `${borderRadius || 8}px`
      }}
    >
      {children}
    </div>
  );
};

ContainerBlock.craft = {
  displayName: 'Section',
  props: {
    backgroundColor: 'transparent',
    padding: 16,
    borderRadius: 8
  },
  related: {
    toolbar: ContainerBlockSettings
  }
};

function ContainerBlockSettings() {
  const { actions: { setProp }, props } = useNode((node) => ({
    props: node.data.props
  }));
  const { isDark } = useTheme();

  const bgColors = [
    { name: 'None', value: 'transparent' },
    { name: 'Dark', value: isDark ? 'rgba(39, 39, 42, 0.5)' : 'rgba(0, 0, 0, 0.05)' },
    { name: 'Brand', value: 'rgba(162, 255, 0, 0.1)' },
    { name: 'White', value: isDark ? 'rgba(255, 255, 255, 0.05)' : 'white' }
  ];

  return (
    <div className="space-y-4">
      <div>
        <label className={`block text-sm font-medium mb-2 ${isDark ? 'text-zinc-300' : 'text-gray-700'}`}>
          Background
        </label>
        <div className="grid grid-cols-2 gap-2">
          {bgColors.map((bg) => (
            <button
              key={bg.name}
              onClick={() => setProp(props => props.backgroundColor = bg.value)}
              className={`px-3 py-2 rounded-lg border text-sm ${
                props.backgroundColor === bg.value
                  ? 'bg-[#A2FF00] text-black border-[#A2FF00]'
                  : isDark ? 'bg-zinc-800 border-zinc-700 text-white' : 'bg-white border-gray-300'
              }`}
            >
              {bg.name}
            </button>
          ))}
        </div>
      </div>
      <div>
        <label className={`block text-sm font-medium mb-1 ${isDark ? 'text-zinc-300' : 'text-gray-700'}`}>
          Padding: {props.padding}px
        </label>
        <input
          type="range"
          min="0"
          max="48"
          value={props.padding}
          onChange={(e) => setProp(props => props.padding = parseInt(e.target.value))}
          className="w-full"
        />
      </div>
      <div>
        <label className={`block text-sm font-medium mb-1 ${isDark ? 'text-zinc-300' : 'text-gray-700'}`}>
          Border Radius: {props.borderRadius}px
        </label>
        <input
          type="range"
          min="0"
          max="24"
          value={props.borderRadius}
          onChange={(e) => setProp(props => props.borderRadius = parseInt(e.target.value))}
          className="w-full"
        />
      </div>
    </div>
  );
}

export { ContainerBlockSettings };